import { useEffect, useState } from "react";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotComics from "./components/HotComics";
import Categories from "./components/Categories";
import Updates from "./components/Updates";
import Features from "./components/Features";
import Ranking from "./components/Ranking";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <main className="min-h-screen">
      <Navbar />
      <Hero />
      <HotComics />
      <Categories />
      <Updates />
      <Features />
      <Ranking />
      <Faq />
      <Subscribe />
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-50 w-11 h-11 flex items-center justify-center rounded-full bg-primary-600 hover:bg-primary-500 text-background-950 shadow-lg cursor-pointer"
        >
          <i className="ri-arrow-up-line text-xl" />
        </a>
      )}
    </main>
  );
}